<template>
    <div class="w-full">
        <div class="container" style="margin-top: 15px">
            <back-button v-if="!$device.isDesktop" :items="breadcrumbs" />

            <div class="banner_content">
                <div class="banner_content_inner w100">
                    <div class="content">
                        <breadcrumbs
                            v-if="$device.isDesktop"
                            :items="breadcrumbs"
                        />
                    </div>
                </div>
            </div>
        </div>
        <div class="b_cr_sub_category">
            <div class="background_decor">
                <picture
                    v-full-image-path:assets="'decor_cr_sub_category.svg'"
                />
            </div>
            <div class="container">
                <div class="page_title">
                    <h1>{{ category.title }}</h1>
                </div>
                <div class="icon_links_wrapper flex">
                    <div
                        v-for="{ id, link, title, isInternalLink } in items"
                        :key="id"
                        class="link_row pointer"
                    >
                        <component
                            :is="isInternalLink ? 'nuxt-link' : 'a'"
                            class="link"
                            :to="isInternalLink ? localePath(link) : null"
                            :href="isInternalLink ? null : link"
                        >
                            <div class="icon">
                                <picture
                                    v-full-image-path:assets="
                                        'icon_link_blue.svg'
                                    "
                                />
                            </div>
                            <div class="title">
                                <h3>
                                    {{ title }}
                                </h3>
                            </div>
                        </component>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import BackButton from '@/components/elements/BackButton';
import Breadcrumbs from '@/components/elements/Breadcrumbs';

export default {
    components: {
        BackButton,
        Breadcrumbs
    },

    props: {
        category: {
            type: Object,
            required: true
        },

        data: {
            type: Array,
            required: true
        }
    },

    computed: {
        items() {
            return this.data.map(item => {
                return {
                    ...item,
                    isInternalLink: item.link.startsWith('/')
                };
            });
        },

        pageTitle() {
            return this.$t('clinicalResearches.pageTitle');
        },

        breadcrumbs() {
            return [
                {
                    text: this.$t('homepage.home'),
                    to: this.localePath('/')
                },
                {
                    text: this.pageTitle,
                    to: this.localePath('/clinical-researches')
                },
                {
                    text: this.category.title,
                    active: true
                }
            ];
        }
    }
};
</script>
